export let ObjectTypeId = /*#__PURE__*/function (ObjectTypeId) {
  ObjectTypeId[ObjectTypeId["USER"] = 2] = "USER";
  ObjectTypeId[ObjectTypeId["INTERACTION"] = 5] = "INTERACTION";
  ObjectTypeId[ObjectTypeId["EMPLOYEE"] = 7] = "EMPLOYEE";
  ObjectTypeId[ObjectTypeId["TASK"] = 11] = "TASK";
  ObjectTypeId[ObjectTypeId["ROLE"] = 17] = "ROLE";
  ObjectTypeId[ObjectTypeId["VIEW"] = 18] = "VIEW";
  ObjectTypeId[ObjectTypeId["MAIN"] = 20] = "MAIN";
  ObjectTypeId[ObjectTypeId["WIDGET"] = 50] = "WIDGET";
  ObjectTypeId[ObjectTypeId["DEPARTMENT"] = 63] = "DEPARTMENT";
  ObjectTypeId[ObjectTypeId["TREE"] = 69] = "TREE";
  ObjectTypeId[ObjectTypeId["TASK_TEMPLATE"] = 70] = "TASK_TEMPLATE";
  ObjectTypeId[ObjectTypeId["COMPANY"] = 73] = "COMPANY";
  ObjectTypeId[ObjectTypeId["SURVEY_CONF"] = 81] = "SURVEY_CONF";
  ObjectTypeId[ObjectTypeId["QUESTION"] = 83] = "QUESTION";
  ObjectTypeId[ObjectTypeId["ANSWER"] = 84] = "ANSWER";
  ObjectTypeId[ObjectTypeId["ANSWERGROUP"] = 85] = "ANSWERGROUP";
  ObjectTypeId[ObjectTypeId["SURVEY"] = 87] = "SURVEY";
  ObjectTypeId[ObjectTypeId["CRONO_TRAIL"] = 88] = "CRONO_TRAIL";
  ObjectTypeId[ObjectTypeId["QUESTIONCONF"] = 90] = "QUESTIONCONF";
  ObjectTypeId[ObjectTypeId["QUESTIONANSWER"] = 91] = "QUESTIONANSWER";
  ObjectTypeId[ObjectTypeId["TYPOLOGY"] = 300] = "TYPOLOGY";
  ObjectTypeId[ObjectTypeId["PARAMETER"] = 301] = "PARAMETER";
  ObjectTypeId[ObjectTypeId["DOCUMENTEDM"] = 302] = "DOCUMENTEDM";
  ObjectTypeId[ObjectTypeId["DOCUMENTALGROUP"] = 303] = "DOCUMENTALGROUP";
  ObjectTypeId[ObjectTypeId["PARAMETERDEFAULTVALUE"] = 304] = "PARAMETERDEFAULTVALUE";
  ObjectTypeId[ObjectTypeId["DOCLOCATORSPECIAL"] = 305] = "DOCLOCATORSPECIAL";
  ObjectTypeId[ObjectTypeId["OBJECTPARAMETER"] = 306] = "OBJECTPARAMETER";
  ObjectTypeId[ObjectTypeId["UBICACION"] = 307] = "UBICACION";
  ObjectTypeId[ObjectTypeId["PALE"] = 308] = "PALE";
  ObjectTypeId[ObjectTypeId["CONTENEDOR"] = 309] = "CONTENEDOR";
  ObjectTypeId[ObjectTypeId["CAJA"] = 310] = "CAJA";
  ObjectTypeId[ObjectTypeId["EXPEDIENTEEDM"] = 311] = "EXPEDIENTEEDM";
  ObjectTypeId[ObjectTypeId["DOCUMENTEDMDATA"] = 312] = "DOCUMENTEDMDATA";
  ObjectTypeId[ObjectTypeId["DOCCONTENTLOCATOR"] = 313] = "DOCCONTENTLOCATOR";
  ObjectTypeId[ObjectTypeId["REPORT"] = 1000] = "REPORT";
  ObjectTypeId[ObjectTypeId["ATTACHMENT"] = 1001] = "ATTACHMENT";
  ObjectTypeId[ObjectTypeId["ARCHIVE"] = 1002] = "ARCHIVE";
  ObjectTypeId[ObjectTypeId["REPORT_TYPE"] = 1020] = "REPORT_TYPE";
  ObjectTypeId[ObjectTypeId["ASSOCIATED_TASK"] = 1021] = "ASSOCIATED_TASK";
  ObjectTypeId[ObjectTypeId["PERSON"] = 1022] = "PERSON";
  ObjectTypeId[ObjectTypeId["BRANCH"] = 1023] = "BRANCH";
  ObjectTypeId[ObjectTypeId["COMMISSIONER"] = 1024] = "COMMISSIONER";
  ObjectTypeId[ObjectTypeId["BANK"] = 1025] = "BANK";
  ObjectTypeId[ObjectTypeId["DELEGATION"] = 1026] = "DELEGATION";
  ObjectTypeId[ObjectTypeId["MORTGAGE_UNIT"] = 1027] = "MORTGAGE_UNIT";
  ObjectTypeId[ObjectTypeId["TERRITORIAL_DIVISION"] = 1028] = "TERRITORIAL_DIVISION";
  ObjectTypeId[ObjectTypeId["ZONAL_DIVISION"] = 1029] = "ZONAL_DIVISION";
  ObjectTypeId[ObjectTypeId["CONTACTPHONE"] = 1030] = "CONTACTPHONE";
  ObjectTypeId[ObjectTypeId["CONTACTNET"] = 1031] = "CONTACTNET";
  ObjectTypeId[ObjectTypeId["CONTACTSPANISHADDRESS"] = 1032] = "CONTACTSPANISHADDRESS";
  ObjectTypeId[ObjectTypeId["CONTACTPERSON"] = 1033] = "CONTACTPERSON";
  ObjectTypeId[ObjectTypeId["BUSINESSUNIT"] = 1034] = "BUSINESSUNIT";
  ObjectTypeId[ObjectTypeId["CAMPAIGN"] = 1035] = "CAMPAIGN";
  ObjectTypeId[ObjectTypeId["WAVE"] = 1036] = "WAVE";
  ObjectTypeId[ObjectTypeId["LEAD"] = 1037] = "LEAD";
  ObjectTypeId[ObjectTypeId["RULE_OLD"] = 1038] = "RULE_OLD";
  ObjectTypeId[ObjectTypeId["CASESSOLUTION"] = 1039] = "CASESSOLUTION";
  ObjectTypeId[ObjectTypeId["CASES"] = 1040] = "CASES";
  ObjectTypeId[ObjectTypeId["SOLUTION"] = 1041] = "SOLUTION";
  ObjectTypeId[ObjectTypeId["ROLEVIEW"] = 1042] = "ROLEVIEW";
  ObjectTypeId[ObjectTypeId["RULEPACKAGE"] = 1043] = "RULEPACKAGE";
  ObjectTypeId[ObjectTypeId["SCHEDULEDTASK"] = 1044] = "SCHEDULEDTASK";
  ObjectTypeId[ObjectTypeId["CUSTOMER"] = 1045] = "CUSTOMER";
  ObjectTypeId[ObjectTypeId["MEANPAYMENT"] = 1046] = "MEANPAYMENT";
  ObjectTypeId[ObjectTypeId["BUSINESS_UNIT_CRMOBJECT"] = 1047] = "BUSINESS_UNIT_CRMOBJECT";
  ObjectTypeId[ObjectTypeId["TRANSACTION"] = 1048] = "TRANSACTION";
  ObjectTypeId[ObjectTypeId["WEBSERVICE"] = 1049] = "WEBSERVICE";
  ObjectTypeId[ObjectTypeId["PRODUCT"] = 1050] = "PRODUCT";
  ObjectTypeId[ObjectTypeId["ORDER"] = 1051] = "ORDER";
  ObjectTypeId[ObjectTypeId["ORDERLINE"] = 1052] = "ORDERLINE";
  ObjectTypeId[ObjectTypeId["EMAILTEMPLATE"] = 1053] = "EMAILTEMPLATE";
  ObjectTypeId[ObjectTypeId["LISTMARKETING"] = 1054] = "LISTMARKETING";
  ObjectTypeId[ObjectTypeId["SMSTEMPLATE"] = 1055] = "SMSTEMPLATE";
  ObjectTypeId[ObjectTypeId["EMAIL"] = 1056] = "EMAIL";
  ObjectTypeId[ObjectTypeId["SMS"] = 1057] = "SMS";
  ObjectTypeId[ObjectTypeId["SUB_INTERACTION"] = 1058] = "SUB_INTERACTION";
  ObjectTypeId[ObjectTypeId["PRODUCTINSTALLED"] = 1059] = "PRODUCTINSTALLED";
  ObjectTypeId[ObjectTypeId["QUERY"] = 1060] = "QUERY";
  ObjectTypeId[ObjectTypeId["INVOICE"] = 1061] = "INVOICE";
  ObjectTypeId[ObjectTypeId["INVOICELINE"] = 1062] = "INVOICELINE";
  ObjectTypeId[ObjectTypeId["QUALIFICATION"] = 1063] = "QUALIFICATION";
  ObjectTypeId[ObjectTypeId["TAMPLATETEXT"] = 1064] = "TAMPLATETEXT";
  ObjectTypeId[ObjectTypeId["LISTROBINSON"] = 1065] = "LISTROBINSON";
  ObjectTypeId[ObjectTypeId["CANAL"] = 1066] = "CANAL";
  ObjectTypeId[ObjectTypeId["SERVICE"] = 1067] = "SERVICE";
  ObjectTypeId[ObjectTypeId["TASKEDITABLE"] = 1068] = "TASKEDITABLE";
  ObjectTypeId[ObjectTypeId["RELATEDPERSON"] = 1069] = "RELATEDPERSON";
  ObjectTypeId[ObjectTypeId["CALL"] = 1070] = "CALL";
  ObjectTypeId[ObjectTypeId["FAX"] = 1071] = "FAX";
  ObjectTypeId[ObjectTypeId["BRANCHSON"] = 1072] = "BRANCHSON";
  ObjectTypeId[ObjectTypeId["ANSWERCODE"] = 1073] = "ANSWERCODE";
  ObjectTypeId[ObjectTypeId["SERVICETRANSACTION"] = 1074] = "SERVICETRANSACTION";
  ObjectTypeId[ObjectTypeId["REASSIGN"] = 1075] = "REASSIGN";
  ObjectTypeId[ObjectTypeId["LOAD"] = 1076] = "LOAD";
  ObjectTypeId[ObjectTypeId["CHECK"] = 1077] = "CHECK";
  ObjectTypeId[ObjectTypeId["DASHBOARD"] = 1080] = "DASHBOARD";
  ObjectTypeId[ObjectTypeId["ACTIVE"] = 1081] = "ACTIVE";
  ObjectTypeId[ObjectTypeId["CONSOLECONFIG"] = 1082] = "CONSOLECONFIG";
  ObjectTypeId[ObjectTypeId["CASESGROUP"] = 1083] = "CASESGROUP";
  ObjectTypeId[ObjectTypeId["CASESTEMPLATE"] = 1084] = "CASESTEMPLATE";
  ObjectTypeId[ObjectTypeId["MANUFACTURER"] = 1085] = "MANUFACTURER";
  ObjectTypeId[ObjectTypeId["MODEL_OLD"] = 1086] = "MODEL_OLD";
  ObjectTypeId[ObjectTypeId["KNOWLEDGEBASE"] = 1087] = "KNOWLEDGEBASE";
  ObjectTypeId[ObjectTypeId["ROLE_REPORT_TYPE"] = 1088] = "ROLE_REPORT_TYPE";
  ObjectTypeId[ObjectTypeId["LIST_MARKETING_PERSON"] = 1089] = "LIST_MARKETING_PERSON";
  ObjectTypeId[ObjectTypeId["RELATEDCRMOBJECT"] = 1090] = "RELATEDCRMOBJECT";
  ObjectTypeId[ObjectTypeId["CALENDAR"] = 1091] = "CALENDAR";
  ObjectTypeId[ObjectTypeId["AGENCY"] = 1092] = "AGENCY";
  ObjectTypeId[ObjectTypeId["SLA_TEMPLATE"] = 1094] = "SLA_TEMPLATE";
  ObjectTypeId[ObjectTypeId["CALENDAR_DATE"] = 1095] = "CALENDAR_DATE";
  ObjectTypeId[ObjectTypeId["SLA"] = 1097] = "SLA";
  ObjectTypeId[ObjectTypeId["SLATEMPLATETIMESLOT"] = 1098] = "SLATEMPLATETIMESLOT";
  ObjectTypeId[ObjectTypeId["SLASCHEDULEDTIMESLOT"] = 1099] = "SLASCHEDULEDTIMESLOT";
  ObjectTypeId[ObjectTypeId["AUDIT"] = 1100] = "AUDIT";
  ObjectTypeId[ObjectTypeId["AUDIT_TYPE"] = 1101] = "AUDIT_TYPE";
  ObjectTypeId[ObjectTypeId["SUPPLIER"] = 1102] = "SUPPLIER";
  ObjectTypeId[ObjectTypeId["REGISTRATION"] = 1103] = "REGISTRATION";
  ObjectTypeId[ObjectTypeId["PROPERTY"] = 1104] = "PROPERTY";
  ObjectTypeId[ObjectTypeId["TASKCALENDAR"] = 1105] = "TASKCALENDAR";
  ObjectTypeId[ObjectTypeId["USERSERVICE"] = 1106] = "USERSERVICE";
  ObjectTypeId[ObjectTypeId["NOCONFORMIDAD"] = 1107] = "NOCONFORMIDAD";
  ObjectTypeId[ObjectTypeId["ACCIONCORRECTIVA"] = 1108] = "ACCIONCORRECTIVA";
  ObjectTypeId[ObjectTypeId["FICHAFORMACION"] = 1109] = "FICHAFORMACION";
  ObjectTypeId[ObjectTypeId["METRICA"] = 1110] = "METRICA";
  ObjectTypeId[ObjectTypeId["PLANTRATAMIENTO"] = 1111] = "PLANTRATAMIENTO";
  ObjectTypeId[ObjectTypeId["ACCIONPLANTRATAMIENTO"] = 1112] = "ACCIONPLANTRATAMIENTO";
  ObjectTypeId[ObjectTypeId["PAC"] = 1113] = "PAC";
  ObjectTypeId[ObjectTypeId["COMPETENCERELATEDOBJECT"] = 1114] = "COMPETENCERELATEDOBJECT";
  ObjectTypeId[ObjectTypeId["NOTARY"] = 1115] = "NOTARY";
  ObjectTypeId[ObjectTypeId["EXTERNOBJECT"] = 1116] = "EXTERNOBJECT";
  ObjectTypeId[ObjectTypeId["VERTICAL"] = 1117] = "VERTICAL";
  ObjectTypeId[ObjectTypeId["PRICE"] = 1118] = "PRICE";
  ObjectTypeId[ObjectTypeId["DOCUMENTTYPE"] = 1119] = "DOCUMENTTYPE";
  ObjectTypeId[ObjectTypeId["RELATEDOBJECTCOMPETENCE"] = 1120] = "RELATEDOBJECTCOMPETENCE";
  ObjectTypeId[ObjectTypeId["EMAILATTACHMENT"] = 1122] = "EMAILATTACHMENT";
  ObjectTypeId[ObjectTypeId["BPM_MODEL"] = 1123] = "BPM_MODEL";
  ObjectTypeId[ObjectTypeId["BUSINESSUNITTREE"] = 1126] = "BUSINESSUNITTREE";
  ObjectTypeId[ObjectTypeId["DOCUMENTALVALIDATION"] = 1127] = "DOCUMENTALVALIDATION";
  ObjectTypeId[ObjectTypeId["BPM_ACTION"] = 1128] = "BPM_ACTION";
  ObjectTypeId[ObjectTypeId["BPM_GATEWAY"] = 1129] = "BPM_GATEWAY";
  ObjectTypeId[ObjectTypeId["BPM_PROCESS"] = 1130] = "BPM_PROCESS";
  ObjectTypeId[ObjectTypeId["DOCUMENTALVALIDATIONLINE"] = 1131] = "DOCUMENTALVALIDATIONLINE";
  ObjectTypeId[ObjectTypeId["FIELDFILTER"] = 1132] = "FIELDFILTER";
  ObjectTypeId[ObjectTypeId["BPM_EVENT"] = 1133] = "BPM_EVENT";
  ObjectTypeId[ObjectTypeId["TEXT"] = 1134] = "TEXT";
  ObjectTypeId[ObjectTypeId["ADMINISTRACIONPUBLICA"] = 1135] = "ADMINISTRACIONPUBLICA";
  ObjectTypeId[ObjectTypeId["BPM_MODEL_VERSION"] = 1136] = "BPM_MODEL_VERSION";
  ObjectTypeId[ObjectTypeId["PROPERTYDEVELOPMENT"] = 1137] = "PROPERTYDEVELOPMENT";
  ObjectTypeId[ObjectTypeId["FULLBANKACCOUNT"] = 1139] = "FULLBANKACCOUNT";
  ObjectTypeId[ObjectTypeId["REGISTERLOGIN"] = 1143] = "REGISTERLOGIN";
  ObjectTypeId[ObjectTypeId["ACCESSLOG"] = 1144] = "ACCESSLOG";
  ObjectTypeId[ObjectTypeId["INVOICEGROUP"] = 1151] = "INVOICEGROUP";
  ObjectTypeId[ObjectTypeId["HISTORICALCHANGE"] = 1152] = "HISTORICALCHANGE";
  ObjectTypeId[ObjectTypeId["PROPERTIES"] = 1153] = "PROPERTIES";
  ObjectTypeId[ObjectTypeId["USERNOTES"] = 1154] = "USERNOTES";
  ObjectTypeId[ObjectTypeId["COMMISSIONTEMPLATE"] = 1155] = "COMMISSIONTEMPLATE";
  ObjectTypeId[ObjectTypeId["COMMISSION"] = 1156] = "COMMISSION";
  ObjectTypeId[ObjectTypeId["MOVIMIENTOS"] = 1160] = "MOVIMIENTOS";
  ObjectTypeId[ObjectTypeId["PROJECT"] = 1167] = "PROJECT";
  ObjectTypeId[ObjectTypeId["PROJECTM"] = 1168] = "PROJECTM";
  ObjectTypeId[ObjectTypeId["COSTPERSM"] = 1169] = "COSTPERSM";
  ObjectTypeId[ObjectTypeId["COSTDIRECTM"] = 1170] = "COSTDIRECTM";
  ObjectTypeId[ObjectTypeId["COSTPROFILEM"] = 1171] = "COSTPROFILEM";
  ObjectTypeId[ObjectTypeId["HOURSDAYPERS"] = 1172] = "HOURSDAYPERS";
  ObjectTypeId[ObjectTypeId["LISTQUERY"] = 1173] = "LISTQUERY";
  ObjectTypeId[ObjectTypeId["LANDINGPAGE"] = 1174] = "LANDINGPAGE";
  ObjectTypeId[ObjectTypeId["LANDINGPAGETEMPLATE"] = 1176] = "LANDINGPAGETEMPLATE";
  ObjectTypeId[ObjectTypeId["ICMM"] = 1177] = "ICMM";
  ObjectTypeId[ObjectTypeId["RULE_INTERACTION"] = 1178] = "RULE_INTERACTION";
  ObjectTypeId[ObjectTypeId["REGISTEREDFAX"] = 1179] = "REGISTEREDFAX";
  ObjectTypeId[ObjectTypeId["HOURSDAYPERSCALENDAR"] = 1187] = "HOURSDAYPERSCALENDAR";
  ObjectTypeId[ObjectTypeId["ROBOT"] = 1191] = "ROBOT";
  ObjectTypeId[ObjectTypeId["PERSONTEMPLATE"] = 1193] = "PERSONTEMPLATE";
  ObjectTypeId[ObjectTypeId["ONLINECOURSE"] = 1202] = "ONLINECOURSE";
  ObjectTypeId[ObjectTypeId["CLASSROOMCOURSE"] = 1203] = "CLASSROOMCOURSE";
  ObjectTypeId[ObjectTypeId["KYC"] = 1214] = "KYC";
  ObjectTypeId[ObjectTypeId["KYCTEMPLATE"] = 1229] = "KYCTEMPLATE";
  ObjectTypeId[ObjectTypeId["ROLEDASHBOARD"] = 1231] = "ROLEDASHBOARD";
  ObjectTypeId[ObjectTypeId["INSPECTIONCHECK"] = 1232] = "INSPECTIONCHECK";
  ObjectTypeId[ObjectTypeId["WIZARD"] = 1233] = "WIZARD";
  ObjectTypeId[ObjectTypeId["KANBAN"] = 1236] = "KANBAN";
  ObjectTypeId[ObjectTypeId["BUNDLEHOURS"] = 1237] = "BUNDLEHOURS";
  ObjectTypeId[ObjectTypeId["SPRINT"] = 1238] = "SPRINT";
  ObjectTypeId[ObjectTypeId["KANBANUSUARIO"] = 1239] = "KANBANUSUARIO";
  ObjectTypeId[ObjectTypeId["SPRINTRESOURCES"] = 1243] = "SPRINTRESOURCES";
  ObjectTypeId[ObjectTypeId["REGISTEREDFAXTEMPLATE"] = 1246] = "REGISTEREDFAXTEMPLATE";
  ObjectTypeId[ObjectTypeId["FAVORITES"] = 1249] = "FAVORITES";
  ObjectTypeId[ObjectTypeId["BPM_MODEL_MARKETING"] = 1258] = "BPM_MODEL_MARKETING";
  ObjectTypeId[ObjectTypeId["CONTRACT"] = 1259] = "CONTRACT";
  ObjectTypeId[ObjectTypeId["DEBT"] = 1260] = "DEBT";
  ObjectTypeId[ObjectTypeId["PAYMENT_AGREEMENT"] = 1261] = "PAYMENT_AGREEMENT";
  ObjectTypeId[ObjectTypeId["DEBT_RECORD"] = 1262] = "DEBT_RECORD";
  ObjectTypeId[ObjectTypeId["ROLE_LOAD_TYPE"] = 1274] = "ROLE_LOAD_TYPE";
  ObjectTypeId[ObjectTypeId["CONFIGURATION_RULE"] = 1288] = "CONFIGURATION_RULE";
  ObjectTypeId[ObjectTypeId["TELEGRAMCHANNEL"] = 1293] = "TELEGRAMCHANNEL";
  ObjectTypeId[ObjectTypeId["BUROFAXCHANNEL"] = 1294] = "BUROFAXCHANNEL";
  ObjectTypeId[ObjectTypeId["DIALOGFLOWCHANNEL"] = 1295] = "DIALOGFLOWCHANNEL";
  ObjectTypeId[ObjectTypeId["FACEBOOKCHANNEL"] = 1296] = "FACEBOOKCHANNEL";
  ObjectTypeId[ObjectTypeId["CHATCHANNEL"] = 1297] = "CHATCHANNEL";
  ObjectTypeId[ObjectTypeId["TWITTERCHANNEL"] = 1298] = "TWITTERCHANNEL";
  ObjectTypeId[ObjectTypeId["API_TRANSACTION"] = 1300] = "API_TRANSACTION";
  ObjectTypeId[ObjectTypeId["SMSCHANNEL"] = 1302] = "SMSCHANNEL";
  ObjectTypeId[ObjectTypeId["PHONECHANNEL"] = 1303] = "PHONECHANNEL";
  ObjectTypeId[ObjectTypeId["TSA_RESPONSE"] = 1308] = "TSA_RESPONSE";
  ObjectTypeId[ObjectTypeId["COMPLIANCE"] = 1310] = "COMPLIANCE";
  ObjectTypeId[ObjectTypeId["STRATEGY"] = 1311] = "STRATEGY";
  ObjectTypeId[ObjectTypeId["COMPETENCY"] = 1312] = "COMPETENCY";
  ObjectTypeId[ObjectTypeId["SIGNATURE"] = 1313] = "SIGNATURE";
  ObjectTypeId[ObjectTypeId["SIGNATURETEMPLATE"] = 1314] = "SIGNATURETEMPLATE";
  ObjectTypeId[ObjectTypeId["SIGNATUREPROCESS"] = 1315] = "SIGNATUREPROCESS";
  ObjectTypeId[ObjectTypeId["SIGNATUREPROCESSTEMPLATE"] = 1316] = "SIGNATUREPROCESSTEMPLATE";
  ObjectTypeId[ObjectTypeId["ATTACHMENT_TEMPLATE"] = 1323] = "ATTACHMENT_TEMPLATE";
  ObjectTypeId[ObjectTypeId["CONFIGURABLEFIELDVALIDATIONTEMPLATE"] = 1333] = "CONFIGURABLEFIELDVALIDATIONTEMPLATE";
  ObjectTypeId[ObjectTypeId["DOCUMENTREQUEST"] = 1346] = "DOCUMENTREQUEST";
  ObjectTypeId[ObjectTypeId["NEW_SURVEY"] = 1351] = "NEW_SURVEY";
  ObjectTypeId[ObjectTypeId["NEW_QUESTION"] = 1352] = "NEW_QUESTION";
  ObjectTypeId[ObjectTypeId["NEW_ANSWER"] = 1353] = "NEW_ANSWER";
  ObjectTypeId[ObjectTypeId["PORTFOLIO"] = 1362] = "PORTFOLIO";
  ObjectTypeId[ObjectTypeId["ICONS"] = 1373] = "ICONS";
  ObjectTypeId[ObjectTypeId["SERVICETEMPLATE"] = 1406] = "SERVICETEMPLATE";
  ObjectTypeId[ObjectTypeId["DASHBOARDTEMPLATE"] = 1413] = "DASHBOARDTEMPLATE";
  ObjectTypeId[ObjectTypeId["PARTIDASPRESUPUESTARIAS"] = 1417] = "PARTIDASPRESUPUESTARIAS";
  ObjectTypeId[ObjectTypeId["CONFIGURABLE_FIELD_VALIDATION_TEMPLATE_GROUP"] = 1455] = "CONFIGURABLE_FIELD_VALIDATION_TEMPLATE_GROUP";
  ObjectTypeId[ObjectTypeId["RULE"] = 1460] = "RULE";
  ObjectTypeId[ObjectTypeId["PHYSICALDELETEREQUEST"] = 1466] = "PHYSICALDELETEREQUEST";
  ObjectTypeId[ObjectTypeId["LOAN"] = 1468] = "LOAN";
  ObjectTypeId[ObjectTypeId["MAPPERCONFIGURATOR"] = 1471] = "MAPPERCONFIGURATOR";
  ObjectTypeId[ObjectTypeId["MAPPERCONFIGURATORENTRY"] = 1472] = "MAPPERCONFIGURATORENTRY";
  ObjectTypeId[ObjectTypeId["SCORING"] = 1473] = "SCORING";
  ObjectTypeId[ObjectTypeId["PHYSICALLYDELETEDOBJECT"] = 1485] = "PHYSICALLYDELETEDOBJECT";
  ObjectTypeId[ObjectTypeId["ZOOM_CHANNEL"] = 1494] = "ZOOM_CHANNEL";
  ObjectTypeId[ObjectTypeId["ZOOM_MEETING"] = 1495] = "ZOOM_MEETING";
  ObjectTypeId[ObjectTypeId["CONSENTSGROUPTEMPLATE"] = 1498] = "CONSENTSGROUPTEMPLATE";
  ObjectTypeId[ObjectTypeId["CONSENTSTEMPLATE"] = 1499] = "CONSENTSTEMPLATE";
  ObjectTypeId[ObjectTypeId["CONSENTSGROUP"] = 1500] = "CONSENTSGROUP";
  ObjectTypeId[ObjectTypeId["CONSENTS"] = 1501] = "CONSENTS";
  ObjectTypeId[ObjectTypeId["CERTIFICATE"] = 1503] = "CERTIFICATE";
  ObjectTypeId[ObjectTypeId["PARTICIPANT"] = 1412] = "PARTICIPANT";
  ObjectTypeId[ObjectTypeId["PARTICIPANT_TEMPLATE"] = 1447] = "PARTICIPANT_TEMPLATE";
  ObjectTypeId[ObjectTypeId["DOSSIER"] = 1415] = "DOSSIER";
  ObjectTypeId[ObjectTypeId["DOSSIER_TEMPLATE"] = 1446] = "DOSSIER_TEMPLATE";
  return ObjectTypeId;
}({});